import React, { type JSX } from "react";
import { createPortal } from "react-dom";
import type { Project } from "../../types/redux";
import type { HeaderMenus } from "./useHeaderMenus";
import ProjectSummaryModal from "../ProjectSummaryModal_Component";
import ChatContextMenu from "../ChatContextMenu_Component";
import RenameChatModal from "../RenameChatModal_Component";
import DeleteChatModal from "../DeleteChatModal_Component";

interface HeaderModalsProps {
  project: Project | null;
  menus: HeaderMenus;
  /** Fired once the delete dialog reports the project is gone. */
  onDeleted: () => void;
}

export default function HeaderModals({
  project,
  menus,
  onDeleted,
}: HeaderModalsProps): JSX.Element {
  return (
    <>
      {/* Context menu — portaled to body to avoid position:fixed breakage under tablet transform */}
      {menus.isHeaderMenuOpen &&
        project?.id &&
        createPortal(
          <ChatContextMenu
            isOpen={true}
            onClose={menus.closeHeaderMenu}
            position={menus.headerMenuPosition}
            onRename={menus.startRename}
            onDelete={menus.startDelete}
          />,
          document.body
        )}

      <ProjectSummaryModal
        isOpen={menus.isProjectModalOpen}
        onClose={menus.closeProjectModal}
        projectName={project?.name}
        projectSummary={project?.summary}
        projectId={project?.id}
        onRename={menus.startRename}
        onDelete={menus.startDelete}
      />

      {project?.id && (
        <RenameChatModal
          isOpen={menus.isRenameModalOpen}
          onClose={menus.closeRenameModal}
          projectId={project.id}
          currentName={project.name || ""}
        />
      )}

      {/* Rendered from the captured target, not `project`, so it survives deletion */}
      {menus.deleteTarget && (
        <DeleteChatModal
          isOpen={true}
          onClose={menus.clearDeleteTarget}
          projectId={menus.deleteTarget.id}
          projectName={menus.deleteTarget.name}
          onDeleted={() => {
            menus.clearDeleteTarget();
            onDeleted();
          }}
        />
      )}
    </>
  );
}
